import 'react-native-gesture-handler';
import 'react-native-reanimated';
import 'expo-router/entry';
